import React from 'react';

import SmartPayables from '@/components/SmartPayables';

const CheckManagementTab = ({ organizationId }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        paddingTop: '20px',
      }}>
      <SmartPayables organizationId={organizationId} />
    </div>
  );
};

export default CheckManagementTab;
